export const environment = {
  production: false,
  apiUrl: "https://apidev.clearline.me",
  selfServicePortalUrl: ""
};
